import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subject } from 'rxjs';
import { IvrService } from '../../../../../../../../common/services/Ivr.service';
import { BsModalService } from 'ngx-bootstrap';
import { UploadService } from '../../../../../../../../common/services/Upload.service';
import { CommonService } from '../../../../../../../../common/services/Common.service';
import { ToastrService } from 'ngx-toastr';
import { IvrgatewayService } from '../../../../../../../../common/services/Ivrgateway.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import * as _ from 'lodash';
import { BaseComponent } from '../../../../../../../../components/base.component';

@Component({
  selector: 'switchboard-ivr-script-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['../../ivr.component.css', '../../../switchboard.component.css'],
})
export class DetailComponent extends BaseComponent {
  @Input() cp: any = {};
  @Output() onBack = new EventEmitter();
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();

  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public change_message: any = [];
  public list: any = [];
  public listState: any = [];
  public listStateType: any = [{ id: '', text: '' }];
  public selectListState: any = [{ id: '', text: '' }];
  public modelFilter: any = {};
  public modalRef2: any = {};
  totalItem: any = 0;
  totalPage: any = 0;
  public is_detail = false;
  public current_cp: any = {};
  public open_form_state = false;
  public form_state_type = 'add';
  public current_state: any = {};
  public is_load_data: any = false;
  public id_delete: number;
  public index_change_delete: number;

  public show_change: any = {};
  public list_change: any = [];
  public index_change = 100;
  public lstAudioFile: any = [{ id: '', text: '' }];

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private ivrService: IvrService,
    private uploadService: UploadService,
    private commonService: CommonService,
    private ivrgatewayService: IvrgatewayService
  ) {
    super(changeDetector, toastr, modalService);
  }

  async ngOnInit() {
    Promise.all([this.getAudioFiles(), this.getStateTypes()]).then(() => {
      this.detailCp(this.cp);
    });
  }

  async detailCp(cp) {
    if (cp) {
      this.is_load_data = true;
      this.current_cp = cp;
      await this.loadState(this.current_cp);
      setTimeout(() => {
        this.is_detail = true;
        this.change_message = [];
        this.index_change = 100;
        this.show_change = {};
        this.open_form_state = false;
        this.ivrService.listChange({ CP_ID: this.current_cp.CP_ID }).subscribe(res => {
          this.list_change = [];
          const data = res.data ? res.data : [];
          if (data.length > 0) {
            data.sort((a, b) => {
              return b.ID - a.ID;
            });
            this.list_change = data.map(e => {
              return {
                ID: e.ID,
                STATE_ID1: e.STATE_ID1.toString(),
                INPUT: e.INPUT.toString(),
                STATE_ID2: e.STATE_ID2.toString(),
              };
            });
          }
          setTimeout(() => {
            this.is_load_data = false;
          }, 500);
        });
      }, 300);
    }
  }

  async getAudioFiles() {
    this.lstAudioFile = [];
    this.ivrgatewayService.listAudios().subscribe(audios => {
      if (audios.status === 200) {
        audios.data.list.forEach(audio => {
          this.lstAudioFile.push({
            id: audio.id,
            text: audio.file_name,
          });
        });
      }
    });
  }

  async loadState(cp) {
    await this.ivrService.listState(cp.CP_ID).subscribe(res => {
      if (!res.error && res.status == 200) {
        const tmp_list = [{ id: '', text: 'Chọn' }];
        this.listState = res.data;
        this.listState.forEach(e => {
          tmp_list.push({
            id: e.STATE_ID.toString(),
            text: e.DESCRIPTION,
          });
        });
        this.selectListState = tmp_list;
      }
    });
  }

  async addFile1($event) {
    this.current_state['FIRST_FILE'] = $event.value;
  }

  async addFile2($event) {
    this.current_state['SECOND_FILE'] = $event.value;
  }

  async addNewChange() {
    this.list_change.unshift({
      STATE_ID1: '',
      INPUT: '',
      STATE_ID2: '',
    });
  }

  async deleteChange(index) {
    const y = confirm('Bạn muốn xóa liên kết này không?');
    if (y) {
      if (this.list_change[index].ID) {
        this.index_change_delete = index;
        await this.submitDeleteChange();
      } else {
        this.list_change.splice(index, 1);
        this.show_change[index] = false;
      }
    }
  }

  async choiceState(event, index, order) {
    if (!this.is_load_data) {
      if (order == 1) {
        this.list_change[index]['STATE_ID1'] = event.value;
      } else {
        this.list_change[index]['STATE_ID2'] = event.value;
      }
    }
  }

  async openConfirmDeleteChange(index) {
    this.index_change_delete = index;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      await this.submitDeleteChange();
    }
  }

  async submitDeleteChange() {
    const id_change = this.list_change[this.index_change_delete].ID;
    this.ivrService.deleteChange(id_change).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Xóa thành công!');
          this.detailCp(this.current_cp);
        } else {
          this.throwError('Xóa không thành công!');
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async submitDeleteState(id) {
    let flag = false;
    for (let i = 0; i < this.list_change.length; i++) {
      if (this.list_change[i].STATE_ID1 == id || this.list_change[i].STATE_ID2 == id) {
        flag = true;
        break;
      }
    }
    if (!flag) {
      const y = confirm('Bạn có muốn xóa trạng thái này không?');
      if (y) {
        this.ivrService.deleteState(id).subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.toastr.error('Xóa không thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.toastr.success('Xóa thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
                this.loadState(this.current_cp);
                // this.modalRef2.hide();
              }
            }
          },
          error => {
            this.message = {
              class: 'alert dark alert-danger',
              content: error.message,
            };
          }
        );
      }
    } else {
      this.toastr.error('Trạng thái đang được liên kết, không thể xóa', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  async saveChange(index) {
    const payload = _.assign({}, this.list_change[index]);
    payload['CP_ID'] = this.current_cp.CP_ID;
    if (payload['INPUT'] || payload['INPUT'] == 0) {
      payload['INPUT'] = payload['INPUT'].toString();
    }

    if (!payload.STATE_ID1) {
      this.change_message[index] = {
        class: 'alert dark alert-danger',
        content: 'State 1 không được bỏ trống !',
      };
    } else if (!payload.STATE_ID2) {
      this.change_message[index] = {
        class: 'alert dark alert-danger',
        content: 'State 2 không được bỏ trống !',
      };
    } else if (!payload.INPUT) {
      this.change_message[index] = {
        class: 'alert dark alert-danger',
        content: 'Ký tự liên kết không được bỏ trống !',
      };
    } else if (payload.STATE_ID1 == payload.STATE_ID2) {
      this.change_message[index] = {
        class: 'alert dark alert-danger',
        content: 'State 1 trùng State 2',
      };
    } else {
      if (payload.ID) {
        const data_update = _.assign({}, payload);
        const change_id = payload.ID;
        delete payload.ID;
        // update
        this.ivrService.updateChange(change_id, data_update).subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.toastr.error('Cập nhật thất bại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.toastr.success('Cập nhật thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
                this.change_message[index] = null;
              }
            }
          },
          error => {
            this.message = {
              class: 'alert dark alert-danger',
              content: error.message,
            };
          }
        );
      } else {
        this.ivrService.createChange(payload).subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.toastr.error('Thêm mới thất bại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.toastr.success('Thêm mới thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });

                this.list_change[index]['ID'] = res.data[0];
                this.change_message[index] = null;
              }
            }
          },
          error => {
            this.toastr.error('Thêm mới thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          }
        );
      }
    }
  }

  async openFormState(state?: any) {
    this.current_state = {};
    this.message = null;
    this.open_form_state = true;
    if (state) {
      this.form_state_type = 'edit';
      this.ivrService.detailState(state.STATE_ID).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.current_state = res.data;
            this.current_state['FIRST_FILE'] =
              typeof this.current_state['FIRST_FILE'] === 'string'
                ? this.current_state['FIRST_FILE'].split(',')
                : this.current_state['FIRST_FILE'] || '';
            this.current_state['SECOND_FILE'] =
              typeof this.current_state['SECOND_FILE'] === 'string'
                ? this.current_state['SECOND_FILE'].split(',')
                : this.current_state['SECOND_FILE'] || '';
          } else {
            this.current_state = state;
            this.current_state['FIRST_FILE'] =
              typeof this.current_state['FIRST_FILE'] === 'string'
                ? this.current_state['FIRST_FILE'].split(',')
                : this.current_state['FIRST_FILE'] || '';
            this.current_state['SECOND_FILE'] =
              typeof this.current_state['SECOND_FILE'] === 'string'
                ? this.current_state['SECOND_FILE'].split(',')
                : this.current_state['SECOND_FILE'] || '';
          }
        },
        error => {
          this.current_state = state;
          this.current_state['FIRST_FILE'] =
            typeof this.current_state['FIRST_FILE'] === 'string'
              ? this.current_state['FIRST_FILE'].split(',')
              : this.current_state['FIRST_FILE'] || '';
          this.current_state['SECOND_FILE'] =
            typeof this.current_state['SECOND_FILE'] === 'string'
              ? this.current_state['SECOND_FILE'].split(',')
              : this.current_state['SECOND_FILE'] || '';
        }
      );
    } else {
      this.current_state = {};
      this.form_state_type = 'add';
    }
  }

  async changedStateType(event) {
    let value = event.value;
    if (!this.is_load_data) {
      if (value === '-1' || value === 'Chọn') value = null;
      this.current_state['TYPE'] = value;
    }
  }

  async changeNextState(event) {
    let value = event.value;
    if (value === '-1' || value === 'Chọn') value = null;
    this.current_state['DEFAULT_NEXT_STATE'] = event.value;
  }

  async saveState() {
    this.current_state['CP_ID'] = this.current_cp.CP_ID;
    if (!this.current_state['BIZ_ID']) {
      delete this.current_state['BIZ_ID'];
    }
    this.current_state['LAST_MODIFY'] = moment().valueOf();
    if (this.current_state['TYPE'] != 6) {
      this.current_state['FIRST_FILE'] = Array.isArray(this.current_state['FIRST_FILE'])
        ? this.current_state['FIRST_FILE'].join(',')
        : this.current_state['FIRST_FILE'] || '';
      this.current_state['SECOND_FILE'] = Array.isArray(this.current_state['SECOND_FILE'])
        ? this.current_state['SECOND_FILE'].join(',')
        : this.current_state['SECOND_FILE'] || '';
    }

    if (!this.current_state['TYPE']) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Loại không được bỏ trống',
      };
      setTimeout(() => {
        this.message = null;
      }, 3000);
      return;
    }

    if (!this.current_state['FIRST_FILE']) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Kịch bản đính kèm không được bỏ trống',
      };
      setTimeout(() => {
        this.message = null;
      }, 3000);
      return;
    }

    if (!this.current_state['DESCRIPTION']) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên STATE không được bỏ trống',
      };
      setTimeout(() => {
        this.message = null;
      }, 3000);
      return;
    }
    const payload = {
      TYPE: this.current_state['TYPE'],
      DEFAULT_NEXT_STATE: this.current_state['DEFAULT_NEXT_STATE'],
      DESCRIPTION: this.current_state['DESCRIPTION'] && this.current_state['DESCRIPTION'].trim(),
      FIRST_FILE: this.current_state['FIRST_FILE'],
      SECOND_FILE: this.current_state['SECOND_FILE'],
      BIZ_ID: this.current_state['BIZ_ID'],
      CP_ID: this.current_cp.CP_ID,
      LAST_MODIFY: moment().valueOf(),
    };
    // Remove keys with no values
    Object.keys(payload).forEach(key => {
      if (key !== 'SECOND_FILE' && (payload[key] === null || payload[key] === undefined || payload[key] === '')) {
        delete payload[key];
      }
    });
    if (this.form_state_type == 'edit') {
      const state_id = parseInt(this.current_state.STATE_ID);
      this.ivrService.updateState(state_id, payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.throwSuccess('Cập nhật thành công!');
            this.loadState(this.current_cp);
            this.detailCp(this.current_cp);
            this.backToListState();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    } else {
      this.ivrService.createState(payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.throwSuccess('Thêm mới thành công!');
            this.loadState(this.current_cp);
            this.detailCp(this.current_cp);
            this.backToListState();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  async backToListState() {
    this.open_form_state = false;
  }

  async getStateTypes() {
    this.ivrService.stateTypes().subscribe(res => {
      const typeList = [{ id: '', text: 'Chọn' }];
      res.data.forEach(e => {
        typeList.push({
          id: e.id,
          text: e.state_type_name,
        });
      });
      this.listStateType = typeList;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/ivr/script/detail/detail.component.ts